<template>
    <section class="content">
        <div class="row">
            <div class="col-md-12">
                <div class="text-right" style="margin-bottom: 15px;" v-if="isOperator">
                    <button
                        class="btn btn-success"
                        @click="confirmRefreshArchiveWeb"
                        :disabled="isRefreshing">
                        <i class="fa fa-refresh" :class="{ 'fa-spin': isRefreshing }"></i>
                        Aggiorna archivio web
                    </button>
                </div>
                <funds-tab v-bind="{requestFunction}" ref="fundsRef" id="fundsId"/>
            </div>
        </div>
    </section>
</template>

<script>
  import types from '../../store/mutation-types'
  import fundsApi from '../../api/funds'
  import fundsTab from '../components/FundsTab'

  export default {
    components: {
      fundsTab
    },

    data () {
      return {
        isRefreshing: false
      }
    },

    computed: {
      isOperator () {
        return this.$accessControl.isOperator(this.$store.state.profile.profile)
      }
    },

    created () {
      this.$store.commit(types.SET_HEADER_STATE, {
        pageTitle: 'Fondi inseriti',
        createButton: {
          display: true,
          text: 'Nuovo fondo',
          to: 'fund'
        }
      })
      this.$emit('addBackgroundColor', 'rgb(244,233,215)')
    },

    methods: {
      requestFunction: function (query) {
        return fundsApi.index(query)
      },
      confirmRefreshArchiveWeb () {
        if (confirm('Sei sicuro di voler aggiornare l\'archivio web? Questa operazione potrebbe richiedere alcuni minuti.')) {
          this.refreshArchiveWeb()
        }
      },
      refreshArchiveWeb () {
        this.isRefreshing = true
        fundsApi.refreshContents()
          .then((response) => {
            this.isRefreshing = false
            toastr.success(response.data.message || 'Archivio web aggiornato con successo')
          })
          .catch((error) => {
            this.isRefreshing = false
            if (error.response && error.response.data && error.response.data.message) {
              toastr.error(error.response.data.message)
            }
          })
      }
    }
  }
</script>

<style>
    .progress-bar {
        color: #333;
        font-weight: bold;
        text-align: center;
    }

    tr {
        cursor: pointer;
    }

</style>



// WEBPACK FOOTER //
// src/components/funds/Index.vue